class DomaineProductCard extends HTMLElement {
  constructor() {
    super();
    this.variants = [];
    this.swatchVariants = [];
  }

  connectedCallback() {
    this.#setMetadata();
    this._trapFocus();
  }

  #setMetadata() {
    const swatchJson = this.querySelector("[data-swatch-json]");
    if (!swatchJson) return;
    this.swatchesData = JSON.parse(swatchJson.textContent || "{}");
    if (Object.keys(this.swatchesData).length === 0) {
      console.warn("No swatches found");
      return;
    }

    const productOptions = JSON.parse(
      this.querySelector("[data-product-options]").textContent || "[]"
    );

    const optionNamesForSorting = productOptions.map((option) =>
      option.name.toLowerCase()
    );

    try {
      this.colorOptionData = JSON.parse(
        this.querySelector("[data-color-options]").textContent || "[]"
      );
      this.activeColorOption = Object.keys(this.colorOptionData)
        .sort(
          (a, b) =>
            optionNamesForSorting.indexOf(a.toLowerCase()) -
            optionNamesForSorting.indexOf(b.toLowerCase())
        )
        .find((key) => this.colorOptionData[key] === true);

      this.productOptions =
        productOptions.find(
          (option) =>
            option.name.toLowerCase() === this.activeColorOption?.toLowerCase()
        )?.values || [];

      // find object in this.swatchesData where optionName = this.activeColorOption
      this.swatches =
        Object.keys(this.swatchesData)
          .map((key) => ({
            name: this.swatchesData[key].optionName,
            options: this.swatchesData[key].options,
          }))
          ?.find(
            (swatch) =>
              swatch.name?.toLowerCase() ===
              this.activeColorOption?.toLowerCase()
          )?.options || [];

      if (!this.swatches.length) {
        return;
      }

      this.swatchImages = [];
      this.productOptions.forEach((option) => {
        const swatch = this.swatches.find(
          (swatch) => swatch.name?.toLowerCase() === option?.toLowerCase()
        );
        if (swatch) {
          this.swatchImages.push(swatch);
        }
      });

      this.variants = JSON.parse(
        this.querySelector("[data-product-variants]").textContent || "[]"
      );

      this.swatchImages.forEach((option) => {
        const relevantVariant = this.variants.find((variant) =>
          variant.options.includes(option.name)
        );

        if (relevantVariant) {
          this.swatchVariants.push({
            ...relevantVariant,
            swatch_image: option.swatch,
            swatch_name: option.name,
          });
        }
      });
      this.colorSwatchesWrapper = this.querySelector("[data-swatches]");

      if (this.swatchVariants?.length > 0) {
        // limit to first 6 swatches
        this.swatchVariants = this.swatchVariants.slice(0, 6);
        this.init();
      } else {
        this.colorSwatchesWrapper?.remove();
      }
    } catch (error) {
      console.error("Error setting metadata:", error);
    }
  }

  init() {
    this.colorSwatchesWrapper = this.querySelector("[data-swatches]");
    this.colorSwatchesWrapper.innerHTML = ""; // Clear existing swatches
    this.swatchVariants.forEach((variant, index) => {
      const swatchName = variant.swatch_name || variant.options?.[0] || "";

      const swatch = document.createElement("button");
      swatch.classList.add("color-swatch");
      swatch.dataset.variantId = variant.id;
      swatch.dataset.productId = variant.product_id;
      swatch.dataset.swatchName = swatchName;

      swatch.dataset.variantImage = variant.variant_image;
      swatch.dataset.variantHoverImage = variant.variant_hover_image;
      swatch.setAttribute("aria-label", variant.title);
      swatch.setAttribute("tabindex", "0");

      if (index == 0) {
        swatch.classList.add("active");
      }

      if (swatchName) {
        const tooltip = document.createElement("span");
        tooltip.classList.add("color-swatch-tooltip");
        tooltip.textContent = swatchName;
        swatch.appendChild(tooltip);
      }

      const img = document.createElement("img");
      img.src = variant.swatch_image;
      img.alt = swatchName;
      img.width = "19";
      img.height = "19";
      swatch.appendChild(img);

      this.colorSwatchesWrapper.appendChild(swatch);
    });

    this.initSwatches();
  }

  initSwatches() {
    const colorSwatches = this.querySelectorAll(".color-swatch");

    colorSwatches.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        colorSwatches.forEach((s) => {
          s.classList.remove("active");
        });

        swatch.classList.add("active");

        const imageUrl = swatch.dataset.variantImage;
        const variantHoverImage = swatch.dataset.variantHoverImage;

        const productImage = this.querySelector(
          "img[data-variant-image-controller]"
        );
        const targetHoverImages = this.querySelector(
          "img[data-variant-image-hover-controller]"
        );

        if (productImage && imageUrl) {
          productImage.classList.add("loading");

          const newImage = new Image();
          newImage.src = imageUrl;

          newImage.onload = function () {
            productImage.src = imageUrl;
            productImage.srcset = imageUrl;
            productImage.classList.remove("loading");
          };

          // add variant id to url

          const variantId = swatch.dataset.variantId;
          const productUrl = this.querySelector("[data-product-link]");

          if (variantId && productUrl) {
            const url = new URL(productUrl.href);
            url.searchParams.set("variant", variantId);
            this.querySelectorAll("[data-product-link]").forEach((link) => {
              link.setAttribute("href", url.href);
            });
          }
        }

        if (variantHoverImage && targetHoverImages) {
          targetHoverImages.src = variantHoverImage;
        }
      });
    });
  }

  _trapFocus() {
    const opener = this.querySelector(".section-open-close__opener");
    const dialog = this.querySelector(".section-open-close__slide");
    let previousFocus = null;

    if (opener && dialog) {
      opener.addEventListener("click", () => {
        // Store current focus
        previousFocus = document.activeElement;

        // Show dialog
        dialog.style.opacity = "1";
        dialog.style.display = "block";

        // Focus the dialog
        dialog.focus();

        // Hide main content from screen readers
        document.querySelector("main")?.setAttribute("aria-hidden", "true");
      });

      const closeButton = dialog.querySelector(".btn-closer");
      if (closeButton) {
        closeButton.addEventListener("click", () => {
          // Hide dialog
          dialog.style.opacity = "0";
          dialog.style.display = "none";

          // Restore focus
          previousFocus?.focus();

          // Restore main content visibility
          document.querySelector("main")?.removeAttribute("aria-hidden");
        });
      }

      // Handle tab key
      dialog.addEventListener("keydown", (e) => {
        if (e.key !== "Tab") return;

        const focusableElements = dialog.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );

        if (!focusableElements.length) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        // Prevent default behavior and handle focus manually
        if (e.shiftKey) {
          if (
            document.activeElement === firstElement ||
            !dialog.contains(document.activeElement)
          ) {
            e.preventDefault();
            lastElement.focus();
          }
        } else {
          if (
            document.activeElement === lastElement ||
            !dialog.contains(document.activeElement)
          ) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      });

      // Handle focus moving outside dialog
      document.addEventListener("focusin", (e) => {
        if (dialog.style.display === "block" && !dialog.contains(e.target)) {
          e.preventDefault();
          dialog.focus();
        }
      });
    }
  }
}

if (!customElements.get("domaine-product-card")) {
  customElements.define("domaine-product-card", DomaineProductCard);
}
